/*
 * @Date: 2021-12-14 17:43:42
 * @LastEditTime: 2024-10-29 11:01:31
 * @Description: file content
 */
import Vue from 'vue';
import { reduce } from 'lodash';
import YSF from '@neysf/qiyu-web-sdk';
import request from './request';
import detectApp from './detect-app';

const wx = require('weixin-js-sdk');

export const uuid = () =>
  Math.random()
    .toString(16)
    .slice(2);

/**
 * @description 联系客服
 * @param {Object} params 传入参数
 * @return 根据不同环境跳转客服聊天页
 */
export function contactCustomerService(params = {}, type = '') {
  const ua = navigator.userAgent.toLowerCase();
  request
    .post('/api/v8/special_service/user_ask/assistant/', params)
    .then((res = {}) => {
      const h5QaIm = `/api/chat/conversation/page/patient/?service_type=medicine_sale&conversation_id=${res.conversation_id}`;
      if (res.conversation_id) {
        // sdk中需拼接域名
        if (ua.match(/CYCallKit/i)) {
          window.location.href = window.location.origin + h5QaIm;
          return;
        }
        if (detectApp.isFromCY()) {
          // app 环境
          if (detectApp.isGreaterAppVersion('8.3.16', true)) {
            window.location.href = `chunyu://launch/webapp/unlimit_qa/?conversation_id=${res.conversation_id}`;
          } else {
            window.location.href = `chunyu://launch/webapp/problem_detail/?problem_id=${res.assistant_problem_id}`;
          }
        } else if (detectApp.isFromWechat()) {
          // 微信小程序环境下
          wx.miniProgram.getEnv(wxres => {
            if (wxres.miniprogram && type !== 'healthy_mall') {
              wx.miniProgram.navigateTo({
                url: `/pages/qa_im_infinite/index?problem_id=${res.conversation_id}&back_up_level=1`, // back_up_level=1 表示从该小程序页面返回时回到上一级页面。（back_up_level=1 不遵循 qa_im_infinite 的 onUnload 中会固定回到 all_service）
              });
            } else {
              window.location.href = h5QaIm;
            }
          });
        } else {
          // 其他环境中
          window.location.href = h5QaIm;
        }
      } else {
        Vue.prototype.$toast(res.error_msg || '请求客服会话失败');
      }
    });
}

export function contactQiYu(queryObj) {
  const objectToQueryString = obj => {
    const qs = reduce(
      obj,
      function(result, value, key) {
        result += `${key}=${value}&`;
        return result;
      },
      ''
    ).slice(0, -1);
    return qs;
  };
  // 在所有环境，都跳转七鱼客服
  if (detectApp.isFromCY()) {
    window.location.href = `chunyu://launch/webapp/online_service/?${objectToQueryString(
      queryObj
    )}`;
  } else if (detectApp.isFromWechat()) {
    console.log('weixin');
    wx.miniProgram.getEnv(wxres => {
      if (wxres.miniprogram) {
        console.log('this is wx mini');
        wx.miniProgram.navigateTo({
          url: `/pages/contact_page/contact_page`,
        });
      } else {
        console.log('this is weixin h5');
        YSF.init('94c9c19ab091b9d12d25874059cffc19', {
          hidden: 1,
        }).then(ysf => {
          ysf('config', {
            // uid: this.userId, // 用户id
            success() {
              ysf('open');
            },
          });
        });
      }
    });
  } else {
    YSF.init('94c9c19ab091b9d12d25874059cffc19', {
      hidden: 1,
    }).then(ysf => {
      ysf('config', {
        // uid: this.userId, // 用户id
        success() {
          ysf('open');
        },
      });
    });
  }
}
export function getQueryStr(key) {
  const queryString = window.location.search.match(
    new RegExp(`[?&]${key}=([^&]*)(&?)`, 'i')
  );
  const val = (queryString && queryString.length > 1 && queryString[1]) || '';
  return decodeURIComponent(val);
}

/**
 * 商城合规需求 - 是否可以直接购买商品
 * @param {boolean} flag 服务器下发的开关
 * @param {string|number} categoryId 商品分类编码
 */
export function allowDirectBuy(flag, categoryId) {
  // flag 为 true 表示可以直接购买
  if (flag) {
    return true;
  }

  // flag 为 false，以下商品不可以直接购买，必须咨询医生后方可购买
  // 101 - 西药/中成药
  // 151 - 中药颗粒
  // 150 - 中药
  // 4 - 医疗器械
  if ([101, 151, 150, 4].indexOf(categoryId) > -1) {
    return false;
  }
  return true;
}
/**
 * 比较两个app版本号
 * @param {string} v1 版本号1
 * @param {string} v2 版本号2
 * @returns {number} 1: v1 > v2, -1: v1 < v2, 0: 相等
 */
export function compareAppVersion(v1, v2) {
  const arr1 = v1.split('.').map(Number);
  const arr2 = v2.split('.').map(Number);
  const len = Math.max(arr1.length, arr2.length);
  for (let i = 0; i < len; i++) {
    const num1 = arr1[i] || 0;
    const num2 = arr2[i] || 0;
    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }
  return 0;
}
